import { render, staticRenderFns } from "./RevenueChange.vue?vue&type=template&id=3725e21e&"
import script from "./RevenueChange.vue?vue&type=script&lang=js&"
export * from "./RevenueChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports